import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Spinner } from "@/components/common";
import { Briefcase, Lock } from "lucide-react";
import { AfiliacionesConsulta } from "@/components/AfiliacionesConsulta";
import { CONTACTO_GENERAL } from "@/components/Contactanos";
import { useAuth } from "@/context/AuthContext";

export default function Vinculacion() {
  const [rows, setRows] = useState(undefined);
  const [error, setError] = useState(false);
  const { user } = useAuth();
  useEffect(() => { api.get("/portal/vinculacion").then((r) => setRows(r.data.vinculacion)).catch(() => { setError(true); setRows(null); }); }, []);
  const MONEDA = ["salario_mensual", "auxilio_transporte", "auxilio_movilidad"];
  const fmt = (r) => (MONEDA.includes(r.key) && /^\d+(\.\d+)?$/.test(String(r.value || "").trim()) ? `$ ${Number(r.value).toLocaleString("es-CO")}` : r.value);
  if (rows === undefined) return <div className="flex h-64 items-center justify-center text-vino-700"><Spinner className="h-6 w-6" /></div>;
  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">Mi vinculación</h1>
        <p className="mt-1 text-sm text-slate-500">Información de tu vinculación laboral registrada por HUMAN.</p>
      </div>
      <div className="flex items-start gap-2 rounded-lg border border-slate-200 bg-slate-50 px-4 py-2.5 text-xs text-slate-600" data-testid="vinculacion-solo-lectura">
        <Lock className="mt-0.5 h-3.5 w-3.5 shrink-0" /> <span>Solo lectura. Estos datos los administra exclusivamente HUMAN; si ves un error, escríbenos por WhatsApp al <a href={CONTACTO_GENERAL.wa} target="_blank" rel="noopener noreferrer" className="font-semibold text-emerald-700 underline" data-testid="vinculacion-contacto-wa">{CONTACTO_GENERAL.numero}</a>.</span>
      </div>
      {error ? (
        <div className="rounded-xl border border-red-200 bg-red-50 p-6 text-center text-sm text-red-700" data-testid="vinculacion-error">No fue posible cargar tu vinculación. Intenta de nuevo más tarde.</div>
      ) : !rows ? (
        <div className="rounded-xl border border-slate-200 bg-white p-8 text-center text-sm text-slate-400" data-testid="vinculacion-vacia"><Briefcase className="mx-auto mb-2 h-8 w-8 text-slate-300" />HUMAN aún no ha registrado tu vinculación laboral.</div>
      ) : (
        <div className="grid grid-cols-1 gap-x-8 gap-y-4 rounded-xl border border-slate-200 bg-white p-5 shadow-sm sm:grid-cols-2 lg:grid-cols-3" data-testid="vinculacion-datos">
          {rows.map((r) => (
            <div key={r.key}>
              <p className="text-xs font-medium uppercase tracking-wide text-slate-400">{r.label}</p>
              <p className="mt-1 text-sm font-medium text-slate-800" data-testid={`vinc-${r.key}`}>{fmt(r) || <span className="text-slate-300">—</span>}</p>
            </div>
          ))}
        </div>
      )}
      <AfiliacionesConsulta base="/portal/afiliaciones" rol="El empleado" empleado={{ nombre: user?.name || "" }} />
    </div>
  );
}
